import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'delegationDate';
export const apiKey = 'CreatedDateTime';
export const type = TYPE_DATE_COMPARISON;

export const delegationDate = {
  id,
  apiKey,
  type,
};
